import { getConfig } from '@shared/lib/config';
import { Typography } from 'antd';

import { EnvBadge } from './EnvBadge';

const { Text } = Typography;

type BrandProps = {
  collapsed?: boolean;
};

/**
 * Логотип в шапке/сайдбаре. В свёрнутом сайдбаре показывает только марку.
 */
export function Brand({ collapsed = false }: BrandProps) {
  const cfg = getConfig();
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        padding: collapsed ? '0 0 0 8px' : '0 4px',
        height: 56,
      }}
    >
      <div
        style={{
          width: 28,
          height: 28,
          borderRadius: 6,
          background: '#0F172A',
          color: '#F8FAFC',
          display: 'grid',
          placeItems: 'center',
          fontWeight: 700,
          fontSize: 14,
          letterSpacing: -0.5,
          flexShrink: 0,
        }}
      >
        P
      </div>
      {!collapsed && (
        <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
          <Text strong style={{ fontSize: 14, letterSpacing: -0.2, color: '#0F172A' }}>
            {cfg.appName}
          </Text>
          <EnvBadge />
        </div>
      )}
    </div>
  );
}
